import { UseQueryResult, useQuery } from "react-query";

import { IExternalListPage } from "../../types/api";
import { IStockStatusHistoryEntry, Inventory } from "../../utils/api";
import { useAuth } from "../useAuth";

export interface IUseGetVariantStockHistoryParameters {
    variantId: string;
    limit: number;
    cursor?: string;
    direction?: string;
}

export const useGetVariantStockHistory = (
    parameters: IUseGetVariantStockHistoryParameters,
): UseQueryResult<IExternalListPage<IStockStatusHistoryEntry>, unknown> => {
    const { variantId, limit, cursor, direction } = parameters;
    const { token } = useAuth();

    return useQuery<IExternalListPage<IStockStatusHistoryEntry>, unknown>(
        ["inventory", variantId, "history", cursor ?? "", direction ?? ""],
        async () => {
            if (!token) {
                throw new Error(
                    "Cannot fetch stock history without authorization token.",
                );
            }

            return await Inventory.getVariantStockHistory({
                variantId,
                limit,
                cursor,
                direction,
                token,
            });
        },
        {
            enabled: !!token && !!variantId,
            keepPreviousData: true,
        },
    );
};
